import { render, staticRenderFns } from "./Template-00.vue?vue&type=template&id=a95277ca&scoped=true&"
import script from "./Template-00.vue?vue&type=script&lang=js&"
export * from "./Template-00.vue?vue&type=script&lang=js&"
import style0 from "./Template-00.vue?vue&type=style&index=0&lang=less&"
import style1 from "./Template-00.vue?vue&type=style&index=1&id=a95277ca&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a95277ca",
  null
  
)

export default component.exports